import {Factory} from './Factory'
import Menu from '../EditorComponents/Form/Menu'
export class FormFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('form'),
      buttonId: this.id('form-button'),
      slug: 'editor-form',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses: {
        phone: [],
        tablet: [],
        desktop:[]
      },
      name: 'Form',
    }
  }

  properties() {
    return {
      content: [
        {key: 'action', component: 'ContentText', text: 'Action', property: 'action'},
        {key: 'lead-tags', component: 'ContentText', text: 'Lead Tags', property: 'leadTags'},
        {key: 'lead-list', component: 'ContentText', text: 'Lead List', property: 'leadList'},
        {key: 'honeypot', component: 'ContentToggle', text:'Has Honeypot', property: 'hasHoneypot'},
        {key: 'labels', component: 'ContentToggle', text:'Labels', property: 'showLabels'},
        {key: 'placeholders', component: 'ContentToggle', text:'Placeholder', property: 'showPlaceholder'},
        {key: 'send-mail', component: 'ContentToggle', text:'Send Mail', property: 'sendMail'},
        {key: 'send-mail-subject', component: 'ContentText', text:'Mail Subject', property: 'sendMailSubject'},
        {key: 'mails-list', component: 'ContentText', text: 'To mails', property: 'toMails'},
        {key: 'recaptcha', component: 'ContentToggle', text:'Has Recaptcha', property: 'hasRecaptcha'},
        {key: 'frontend-validation', component: 'ContentToggle', text:'Validate', property: 'frontendValidation'},
      ],
      styles: [
        {key: 'margin', component:'MarginProperty'},
      ],
      labelStyles: [
        {key: 'text-color', component:'TextColorProperty', styles: 'labelStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class: 'labelClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class: 'labelClasses'},
      ],
      inputsStyles: [
        {key: 'size', component:'InputSizeProperty', class: 'inputClasses'},
        {key: 'background-color', text: 'background', component:'BackgroundProperty', only: ['color'], styles: 'inputStyles'},
        {key: 'background-focus-color', text: 'focused background', component:'BackgroundProperty', styles: 'focusedInputStyles', only: ['color'],},
        {key: 'background-error-color', text: 'error background', component:'BackgroundProperty', styles: 'errorInputStyles', only: ['color'],},
        {key: 'border', component:'BorderProperty', class: 'inputClasses', styles: 'inputStyles'},
        {key: 'focus-border', component:'BorderProperty', text: 'focused border color', class: 'inputClasses', styles: 'focusedInputStyles', only: ['color']},
        {key: 'error-border', component:'BorderProperty', text: 'error border color', class: 'inputClasses', styles: 'errorInputStyles', only: ['color']},
        {key: 'rounded', component:'RoundedProperty', class: 'inputClasses'},
        {key: 'text-color', component:'TextColorProperty', styles: 'inputStyles'},
      ],
      buttonStyles: [
        {key: 'size', component:'InputSizeProperty', class: 'buttonClasses'},
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], styles: 'buttonStyles'},
        {key: 'border', component:'BorderProperty', class: 'buttonClasses', styles: 'buttonStyles'},
        {key: 'rounded', component:'RoundedProperty', class: 'buttonClasses'},
        {key: 'text-color', component:'TextColorProperty', styles: 'buttonStyles'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
